import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as validate from '../../state';
import { Identity } from '@app/auth/models';

@Component({
  selector: 'tc-validate-email',
  templateUrl: './validate-email.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidateEmailComponent {
  @Input()
  identity?: Identity;

  @Input()
  verify2FAError?: { code: string };

  @Input()
  pending?: boolean;

  @Input()
  linkValid?: boolean;

  @Input()
  validateError?: string;

  @Input()
  validateValue?: string;

  @Input()
  backupCodes?: string[];

  @Output()
  readonly validateIdentity = new EventEmitter<validate.ValidateIdentity>();
}
